import { useStateUrlParamsArray } from "@common/hooks/useStateUrlParams";
import { setFirstLetterToLowerCase } from "@common/stringOperations";
import { useTranslation } from "@localization/useTranslation";
import { RiskLevel } from "../../../legalEntity/legalEntityClassificationTab/LegalEntityClassificationTab.types";
import { useDownloadInternalAssessmentReport } from "../../DownloadInternalAssessmentReport.hooks";
import { InternalAssessmentReportTableProps } from "../InternalAssessmentReportTable.types";
import { useInternalAssessmentReportRows } from "../InternalAssessmentReportTable.hooks";
import { filterBySelection, toSelectOptions } from "@common/components/managementReport/managementReportFilters";

export default function useInternalAssessmentReportCompletedAssessments(props: InternalAssessmentReportTableProps) {
    const { translateString, translateEvaluationEnum } = useTranslation();

    const [searchedRiskLevel, setSearchedRiskLevel] = useStateUrlParamsArray("riskLevel", []);
    const [searchedScore, setSearchedScore] = useStateUrlParamsArray("assessmentScore", []);
    const [searchedEvaluation, setSearchedEvaluation] = useStateUrlParamsArray("assessmentEvaluation", []);

    const { onDownloadReportAsPdf, getReportPdfUrl, isDownloadingPdf } = useDownloadInternalAssessmentReport();

    const rows = useInternalAssessmentReportRows(props.assessments);

    const riskLevelFilterOptions = toSelectOptions(
        rows.map((row) =>
            row.riskLevel === undefined
                ? undefined
                : { id: row.riskLevel.toString(), name: translateString(setFirstLetterToLowerCase(RiskLevel[row.riskLevel])) }
        )
    );

    const scoreFilterOptions = toSelectOptions(rows.map((row) => (row.score === undefined ? undefined : { id: row.score.toString(), name: `${row.score} %` })));

    const evaluationFilterOptions = toSelectOptions(
        rows.map((row) =>
            row.evaluationStatus === undefined
                ? undefined
                : { id: row.evaluationStatus.toString(), name: translateEvaluationEnum(row.evaluationStatus.toString()) }
        )
    );

    let filteredRows = filterBySelection(rows, searchedRiskLevel, (row) => row.riskLevel?.toString());
    filteredRows = filterBySelection(filteredRows, searchedScore, (row) => row.score?.toString());
    filteredRows = filterBySelection(filteredRows, searchedEvaluation, (row) => row.evaluationStatus?.toString());

    return {
        rows: filteredRows,
        onDownloadReportAsPdf,
        getReportPdfUrl,
        isDownloadingPdf,
        searchedRiskLevel,
        setSearchedRiskLevel,
        riskLevelFilterOptions,
        searchedScore,
        setSearchedScore,
        scoreFilterOptions,
        searchedEvaluation,
        setSearchedEvaluation,
        evaluationFilterOptions,
    };
}
